import { InfoFiles } from '../../services/journey.service';
import MyFilesV2Model from '../MyFilesV2/model';

export default class ExamsV2Model {
  static getFirstThree(exams: InfoFiles[]): InfoFiles[] {
    return MyFilesV2Model.sortByDate(exams).slice(0, 3);
  }

  static hasExams(exams: InfoFiles[]): boolean {
    return exams.length > 0;
  }
}
